import React from "react";
import { useTranslation } from "react-i18next";
import { TelePhone, DisplayPhotos } from "@egovernments/digit-ui-react-components";
import Reason from "./Reason";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const TLCaption = ({ data, OpenImage }) => {
  const { t } = useTranslation();
  return (
    <div>
      {data.date && <p>{data.date}</p>}
      <p>{data.name}</p>
      {data.mobileNumber && <TelePhone mobile={data.mobileNumber} />}
      {data.source && <p>{t("ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_" + data.source.toUpperCase())}</p>}
      {data.comment && <Reason otherComment={data?.otherComment} headComment={data?.comment}></Reason>}
      {data?.wfComment ? (
        <div>
          {data?.wfComment?.map((e) => (
            <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
              <h3>{t("WF_COMMON_COMMENTS")}</h3>
              {/* <p>{e}</p> */}
              <i>{<SafeHtml html={e} />}</i>
            </div>
          ))}
        </div>
      ) : null}
      {data?.thumbnailsToShow?.thumbs?.length > 0 ? (
        <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
          <h3>{t("CS_COMMON_ATTACHMENTS")}</h3>
          {/* <PictureAsPdfIcon style={{ color: 'red' }} srcs={data?.thumbnailsToShow.thumbs} onClick={(src, index) => {OpenImage(src, index,data?.thumbnailsToShow)}} /> */}
          <DisplayPhotos
            srcs={data?.thumbnailsToShow.thumbs}
            onClick={(src, index) => {
              OpenImage(src, index, data?.thumbnailsToShow);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default TLCaption;
